var $bf3db9380bba0f1b$exports = {};
"use strict";
const $bf3db9380bba0f1b$var$contactName = document.getElementById("contact-name");
const $bf3db9380bba0f1b$var$contactEmail = document.getElementById("contact-email");
const $bf3db9380bba0f1b$var$contactMessage = document.getElementById("contact-message");
const $bf3db9380bba0f1b$var$contactMessageValidationError = document.getElementById("contact-message-validation-error");
document.getElementById("send-enquiry-button").addEventListener("click", function(e) {
    if ($bf3db9380bba0f1b$var$contactMessage.value) {
        const body = encodeURIComponent($bf3db9380bba0f1b$var$contactMessage.value) + "%0A%0A" + encodeURIComponent($bf3db9380bba0f1b$var$contactName.value);
        window.location.href = "mailto:rob@wearebookable.com?subject=Website%20Enquiry&body=" + body;
        $bf3db9380bba0f1b$var$contactName.value = "";
        $bf3db9380bba0f1b$var$contactEmail.value = "";
        $bf3db9380bba0f1b$var$contactMessage.value = "";
        $bf3db9380bba0f1b$var$contactMessageValidationError.classList.add("hidden");
    } else $bf3db9380bba0f1b$var$contactMessageValidationError.classList.remove("hidden");
});


//# sourceMappingURL=bookable_com.910d90c5.js.map
